import useTranslation from 'customHooks/translate';
import CurrencyFlag from 'react-currency-flags';

interface CurrencyItem {
  currencyId: string;
  totalAmount: number;
}
interface SummaryItem {
  totalByCurrency: CurrencyItem[];
  totalInDefaultCurrency: number;
  defaultCurrency: string;
}

interface IProps {
  title: string;
  summaryData: SummaryItem;
}

export const IncomesSummary = ({ title, summaryData }: IProps) => {
  const translation = useTranslation();

  return (
    <div className="flex flex-col gap-[10px] p-[16px]">
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">{title}</p>
        {summaryData?.totalByCurrency?.map((total, index) => (
          <div
            className="flex items-center gap-[4px] text-[16px] font-medium text-[#1D1D1D]"
            key={index}
          >
            <CurrencyFlag
              className="currency-flag"
              currency={total.currencyId}
            />
            <span>
              {' '}
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(total.totalAmount || 0)}{' '}
            </span>
            <span>{total.currencyId}</span>
          </div>
        ))}
      </div>
      <div className="flex h-max flex-col justify-between gap-[10px] rounded-[4px] bg-[#F5F7F9] p-[16px]">
        <p className="text-[18px] font-semibold text-[#1D1D1D]">
          {translation.reports.TotalIncomes}
        </p>
        <div className="flex items-center gap-[4px]">
          <CurrencyFlag
            className="currency-flag"
            currency={summaryData?.defaultCurrency}
          />
          <p className="text-[16px] font-medium text-[#1D1D1D]">
            <span>
              {' '}
              {new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(summaryData?.totalInDefaultCurrency || 0)}{' '}
            </span>
            <span> {summaryData?.defaultCurrency}</span>
          </p>
        </div>
      </div>
    </div>
  );
};
